export default __webpack_public_path__ + "static/media/inbox-and-docs.eb1c9270.svg";